<template>
    <div>
        Farmacia!
    </div>
</template>

<script>
    export default {
        
    }
</script>
